module.exports = __webpack_public_path__ + "img/screen4.7b3c026.png";